import type { SearchHit } from "services/searchHit";
import type { Image } from "bildebanken-model";
import type { DraggableImage } from "./types";
import type { ImageSource } from "state/page";

export function mapSearchHitToFolderImage(searchHit: SearchHit): DraggableImage {
  return {
    id: searchHit.id,
    thumbnail: searchHit.thumbnailUrl || undefined,
    title: searchHit.metadata.title || "Ingen tittel",
    type: searchHit.type === "Mimir" ? "Bildebanken" : searchHit.type,
  };
}

export function mapSearchHitsToFolderImage(searchHits: SearchHit[]): DraggableImage[] {
  return searchHits.map((hit) => mapSearchHitToFolderImage(hit));
}

export function mapImageToFolderImage(image: Image, itemSource: ImageSource): DraggableImage {
  return {
    id: image.id,
    thumbnail: image.thumbnail || undefined,
    title: image.metadata.title || "Ingen tittel",
    type: itemSource,
  };
}
